// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DtaThinkingStepsResponseThinkingStepsInner } from './dta-thinking-steps-response-thinking-steps-inner';
import {
    DtaThinkingStepsResponseThinkingStepsInnerFromJSON,
    DtaThinkingStepsResponseThinkingStepsInnerFromJSONTyped,
    DtaThinkingStepsResponseThinkingStepsInnerToJSON,
    DtaThinkingStepsResponseThinkingStepsInnerToJSONTyped,
} from './dta-thinking-steps-response-thinking-steps-inner';

/**
 * 
 * @export
 * @interface DtaThinkingStepsResponse
 */
export interface DtaThinkingStepsResponse {
    /**
     * 
     * @type {string}
     * @memberof DtaThinkingStepsResponse
     */
    dta_id: string;
    /**
     * 
     * @type {Array<DtaThinkingStepsResponseThinkingStepsInner>}
     * @memberof DtaThinkingStepsResponse
     */
    thinking_steps: Array<DtaThinkingStepsResponseThinkingStepsInner>;
}

/**
 * Check if a given object implements the DtaThinkingStepsResponse interface.
 */
export function instanceOfDtaThinkingStepsResponse(value: object): value is DtaThinkingStepsResponse {
    if (!('dta_id' in value) || value['dta_id'] === undefined) return false;
    if (!('thinking_steps' in value) || value['thinking_steps'] === undefined) return false;
    return true;
}

export function DtaThinkingStepsResponseFromJSON(json: any): DtaThinkingStepsResponse {
    return DtaThinkingStepsResponseFromJSONTyped(json, false);
}

export function DtaThinkingStepsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DtaThinkingStepsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dta_id': json['dta_id'],
        'thinking_steps': ((json['thinking_steps'] as Array<any>).map(DtaThinkingStepsResponseThinkingStepsInnerFromJSON)),
    };
}

export function DtaThinkingStepsResponseToJSON(json: any): DtaThinkingStepsResponse {
    return DtaThinkingStepsResponseToJSONTyped(json, false);
}

export function DtaThinkingStepsResponseToJSONTyped(value?: DtaThinkingStepsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dta_id': value['dta_id'],
        'thinking_steps': ((value['thinking_steps'] as Array<any>).map(DtaThinkingStepsResponseThinkingStepsInnerToJSON)),
    };
}
